import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";

export default function ContactPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  const page = simple_pages_helper.find("contact");

  return {
    props: {
      meta: {
        title: createTitle("Contact us"),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              {
                label: "Contact us",
                href: getRoute("contact"),
              },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: {
              path: "page.contact.component.Header.title",
              placeholder: "Contact Us",
            },
            description: {
              path: "page.contact.component.Header.description",
              placeholder:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            },
            // img: "page.contact.component.Header.image",
          },
        },
        {
          id: "ContactPageContent",
          component: "ContactPageContent",
          props: {
            body: page["body"] ?? "No contact page details.",
          },
        },
        {
          id: "ContactForm",
          component: "ContactPageForm",
          props: {
            className: "bg-primary text-white py-4 py-md-5",
            title: {
              path: "page.contact.component.ContactPageForm.title",
              placeholder: "Send us a message",
            },
          },
        },
      ],
    },
  };
}
